/* Calculadora de litros, peso lleno y filtro.
   Los numeros de la formula vienen del snippet cotiza-acuario-config.liquid (el mismo JSON del cotizador),
   leido desde <script data-calc-config>. Los filtros de la tienda vienen de <script data-calc-filtros>.
   Sin JS la pagina igual muestra el ejemplo de 100 x 40 x 30 cm y la tabla de medidas comunes. */
(function () {
  'use strict';

  /* FORMULA-INICIO (este trozo lo prueba Scripts/calculadora.py revisar con node, contra la formula del cotizador) */
  function hacerFormula(c) {
    /* L = largo, A = alto, P = fondo (cm). mmElegido = numero o null (automatico: tabla del cotizador). */
    function grosorTabla(L, A, P) {
      for (var i = 0; i < c.grosores.length; i++) {
        var x = c.grosores[i];
        if (L <= x.largoHasta && P <= x.fondoHasta && A <= x.altoHasta) return x.mm;
      }
      return null;
    }
    function calcular(L, A, P, mmElegido) {
      var r = { L: L, A: A, P: P };
      r.litros = L * A * P / 1000;
      r.litrosRed = Math.round(r.litros);
      r.borde = Math.round(L * Math.max(A - 3, 0) * P / 1000);
      r.area = (L * P + 2 * L * A + 2 * P * A) / 10000;
      r.mmTabla = grosorTabla(L, A, P);
      r.enTabla = r.mmTabla !== null;
      r.mm = mmElegido ? mmElegido : (r.enTabla ? r.mmTabla : 10);
      r.peso = Math.round((r.litros + r.area * r.mm * c.kgPorM2PorMm) / c.pesoRedondeo) * c.pesoRedondeo;
      r.filtroMin = Math.ceil(5 * r.litros / 50) * 50;
      /* Se puede cotizar: dentro de los limites del cotizador y pasa sus reglas (igual que calcular() del cotizador) */
      var lim = c.limites;
      var dentro = L >= lim.largo.min && L <= lim.largo.max && A >= lim.alto.min && A <= lim.alto.max && P >= lim.fondo.min && P <= lim.fondo.max;
      var reglas = A <= c.reglas.altoMaxSobreFondo * P && P <= c.reglas.fondoMaxSobreLargo * L;
      r.cotizable = dentro && reglas && r.enTabla;
      return r;
    }
    return calcular;
  }
  /* FORMULA-FIN */

  function leerJSON(root, sel, porDefecto) {
    var el = root.querySelector(sel);
    if (!el) return porDefecto;
    try { return JSON.parse(el.textContent); } catch (e) { return porDefecto; }
  }

  function miles(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function iniciar(root) {
    var CONFIG = leerJSON(root, '[data-calc-config]', null);
    if (!CONFIG) return;
    var FILTROS = leerJSON(root, '[data-calc-filtros]', []).filter(function (f) { return f.hastaCm > 0; });
    FILTROS.sort(function (a, b) { return a.hastaCm - b.hastaCm; });
    var calcular = hacerFormula(CONFIG);
    var COTIZADOR = root.getAttribute('data-calc-cotizador') || '/pages/acuarios-a-medida';
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    var $ = function (n) { return root.querySelector('[data-calc="' + n + '"]'); };
    var $d = function (n) { return root.querySelector('[data-dib="' + n + '"]'); };
    var iL = $('largo'), iA = $('alto'), iP = $('fondo'), sV = $('vidrio');
    var LIM = { largo: [10, 300], alto: [10, 150], fondo: [10, 100] };

    /* Filtro de la tienda: el bloque por largo; si su caudal no llega a 5 x litros, se sube al siguiente.
       Si ninguno alcanza (o el acuario es mas largo que todos), no se sugiere y se avisa. */
    function filtroPara(L, litros) {
      var necesita = 5 * litros;
      var i = -1;
      for (var k = 0; k < FILTROS.length; k++) { if (L <= FILTROS[k].hastaCm) { i = k; break; } }
      if (i < 0) return null;
      while (i < FILTROS.length && FILTROS[i].caudal > 0 && FILTROS[i].caudal < necesita) i++;
      if (i >= FILTROS.length) return null;
      return FILTROS[i];
    }

    /* Dibujo de frente: el vidrio sigue la proporcion largo:alto, el agua queda 3 cm bajo el borde */
    var DIB = { ancho: 400, alto: 176, margen: 48, arriba: 14, abajo: 29, maxW: 304, maxH: 122 };
    function dibujar(L, A, litros) {
      var k = Math.min(DIB.maxW / L, DIB.maxH / A);
      var w = Math.max(40, L * k), h = Math.max(24, A * k);
      var x = DIB.ancho / 2 - w / 2, y = DIB.arriba + (DIB.maxH - h) / 2 + 11;
      var nivel = Math.min(h - 4, Math.max(2, 3 * k));
      $d('vidrio').setAttribute('x', x.toFixed(1)); $d('vidrio').setAttribute('y', y.toFixed(1));
      $d('vidrio').setAttribute('width', w.toFixed(1)); $d('vidrio').setAttribute('height', h.toFixed(1));
      $d('agua').setAttribute('x', (x + 3).toFixed(1)); $d('agua').setAttribute('y', (y + nivel).toFixed(1));
      $d('agua').setAttribute('width', (w - 6).toFixed(1)); $d('agua').setAttribute('height', (h - nivel - 3).toFixed(1));
      $d('nivel').setAttribute('x1', (x + 3).toFixed(1)); $d('nivel').setAttribute('x2', (x + w - 3).toFixed(1));
      $d('nivel').setAttribute('y1', (y + nivel).toFixed(1)); $d('nivel').setAttribute('y2', (y + nivel).toFixed(1));
      var tl = $d('t-largo'); tl.setAttribute('x', (x + w / 2).toFixed(1)); tl.setAttribute('y', (y + h + 21).toFixed(1)); tl.textContent = L + ' cm';
      var ta = $d('t-alto'); ta.setAttribute('x', (x + w + 14).toFixed(1)); ta.setAttribute('y', (y + h / 2 + 5).toFixed(1)); ta.textContent = A + ' cm';
      var tv = $d('t-litros'); tv.setAttribute('x', (x + w / 2).toFixed(1)); tv.setAttribute('y', (y + h / 2 + 9).toFixed(1));
      tv.textContent = miles(litros) + ' L';
      tv.style.display = (w < 90 || h < 34) ? 'none' : '';
      $('dibujo').setAttribute('aria-label', 'Acuario de ' + L + ' cm de largo y ' + A + ' cm de alto, visto de frente, con el agua a 3 cm del borde');
    }

    function leer(el, nombre) {
      var v = parseFloat(String(el.value).replace(',', '.'));
      if (isNaN(v)) return null;
      return v;
    }
    function fueraDeRango(v, nombre) {
      return v < LIM[nombre][0] || v > LIM[nombre][1];
    }

    var ultimoFiltro = null, anuncioT = 0, estado = null;

    function render(inicial) {
      var L = leer(iL), A = leer(iA), P = leer(iP);
      var err = $('error');
      var faltan = [L, A, P].some(function (v) { return v === null; });
      var fuera = (L !== null && fueraDeRango(L, 'largo')) || (A !== null && fueraDeRango(A, 'alto')) || (P !== null && fueraDeRango(P, 'fondo'));
      if (faltan || fuera) {
        err.textContent = faltan
          ? 'Ponga las tres medidas en centímetros.'
          : 'Largo de 10 a 300 cm, alto de 10 a 150 y fondo de 10 a 100. Para algo más grande, escríbanos.';
        err.hidden = false;
        root.classList.add('cl-sin-medida');
        return;
      }
      err.hidden = true; err.textContent = '';
      root.classList.remove('cl-sin-medida');

      var mmElegido = sV && sV.value !== 'auto' ? Number(sV.value) : null;
      var r = calcular(L, A, P, mmElegido);
      estado = r;

      $('litros').textContent = miles(r.litrosRed);
      $('borde').textContent = miles(r.borde);
      $('peso').textContent = miles(r.peso) + ' kg';
      $('mm').textContent = r.mm + ' mm';
      $('aviso-vidrio').hidden = !(mmElegido === null && !r.enTabla);
      $('fmin').textContent = miles(r.filtroMin) + ' L/h';
      dibujar(L, A, r.litrosRed);

      if (FILTROS.length && $('filtro')) {
        var f = filtroPara(L, r.litros);
        $('filtro').hidden = !f;
        $('filtro-nota').hidden = !!f;
        if (f && f !== ultimoFiltro) {
          ultimoFiltro = f;
          var img = $('f-img');
          if (f.img) { img.src = f.img; img.alt = f.nombre; img.hidden = false; } else { img.hidden = true; }
          $('f-nom').textContent = f.nombre;
          $('f-pre').textContent = f.precio;
          $('f-nota').textContent = 'Mueve ' + miles(f.caudal) + ' L/h y sirve hasta ' + f.hastaCm + ' cm de largo.';
          if (f.url) $('f-link').href = f.url;
        }
      }

      var btn = $('cotizar');
      btn.hidden = !r.cotizable;
      $('cotizar-nota').hidden = !r.cotizable;
      $('no-fab').hidden = r.cotizable;
      if (r.cotizable) {
        btn.href = COTIZADOR + '?largo=' + L + '&alto=' + A + '&fondo=' + P + '#cotiza';
      }

      clearTimeout(anuncioT);
      if (!inicial) {
        anuncioT = setTimeout(function () {
          $('anuncio').textContent = 'Acuario de ' + L + ' por ' + A + ' por ' + P + ' centímetros: ' + miles(r.litrosRed) +
            ' litros, pesa lleno unos ' + miles(r.peso) + ' kilos, filtro de ' + miles(r.filtroMin) + ' litros por hora o más.';
        }, 700);
      }
    }

    [iL, iA, iP].forEach(function (el) {
      el.addEventListener('input', function () { render(false); guardarURL(); });
      el.addEventListener('focus', function () { try { el.select(); } catch (e) { /* nada */ } });
    });
    if (sV) sV.addEventListener('change', function () { render(false); });
    $('form').addEventListener('submit', function (ev) { ev.preventDefault(); render(false); });

    /* Medida en el link: ?largo=100&alto=40&fondo=30 (opcional) */
    function entero(v) {
      if (v === null || v === undefined || !/^\s*\d+\s*$/.test(String(v))) return null;
      var n = parseInt(v, 10);
      return n > 0 ? n : null;
    }
    var hayParams = false;
    try {
      var q = new URLSearchParams(window.location.search);
      var m = { largo: entero(q.get('largo')), alto: entero(q.get('alto')), fondo: entero(q.get('fondo')) };
      if (m.largo !== null && m.alto !== null && m.fondo !== null) {
        iL.value = String(m.largo); iA.value = String(m.alto); iP.value = String(m.fondo);
        hayParams = true;
      }
    } catch (e) { /* sin URLSearchParams: se queda el ejemplo */ }

    var urlT = 0;
    function guardarURL() {
      clearTimeout(urlT);
      urlT = setTimeout(function () {
        try {
          var L = leer(iL), A = leer(iA), P = leer(iP);
          if (L === null || A === null || P === null) return;
          var enEjemplo = L === 100 && A === 40 && P === 30;
          if (enEjemplo && !hayParams) return;
          var q2 = new URLSearchParams(window.location.search);
          q2.set('largo', String(L)); q2.set('alto', String(A)); q2.set('fondo', String(P));
          history.replaceState(null, '', window.location.pathname + '?' + q2.toString() + '#calcular');
          hayParams = true;
        } catch (e) { /* sin historial (vista previa): no pasa nada */ }
      }, 250);
    }

    /* Tabla de medidas comunes: el boton carga la medida y sube a la calculadora */
    Array.prototype.forEach.call(root.querySelectorAll('[data-calc-medida]'), function (b) {
      b.addEventListener('click', function () {
        var m = (b.getAttribute('data-calc-medida') || '').split(',').map(Number);
        if (m.length !== 3 || m.some(isNaN)) return;
        iL.value = String(m[0]); iA.value = String(m[1]); iP.value = String(m[2]);
        if (sV) sV.value = 'auto';
        render(false);
        guardarURL();
        root.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    render(true);
    if (hayParams) render(false);

    /* Para revisar la formula desde la consola */
    root.calculadoraAcuario = { calcular: calcular, config: CONFIG, filtros: FILTROS, filtroPara: filtroPara };
  }

  function arrancar() {
    var roots = document.querySelectorAll('[data-calculadora]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].calculadoraAcuario) iniciar(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
